export default "# Combinators\n\n![Union](union.doc)\n![Intersect](intersect.doc)\n![Difference](difference.doc)\n![Lerp](lerp.doc)\n";